import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, Transitions } from "../../../../types"
import { getServiceErrorMessage } from "../../../../helpers"

export const toggleBreakBeforeLessonTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    src: "toggleBreakBeforeLesson",
    onDone: {
      target: "idle",
      actions: assign({
        studyPlan: (_ctx, evt) => evt.data.result.plan,
        snackbar: (_ctx, evt) => ({
          message: `Break ${
            evt.data.breakStatus ? "added" : "removed"
          } successfully.`,
          withUndo: false,
          variant: "success"
        })
      })
    },
    onError: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, _evt) => ({
          message: getServiceErrorMessage("toggleBreakBeforeLesson", {
            messageData: ["toggle break before lesson"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
